import { backendApiUrl, landbotApiUrl } from "../../util/env-utils";
import {
  DefaultApi as BackendApi,
  ConfigurationParameters as BackendConfigurationParameters,
  ErrorContext as BackendErrorContext,
  RequestContext as BackendRequestContext,
  ResponseContext as BackendResponseContext,
  GetMeMamaDiseaseEnum as DiseaseEnum,
  GetMeMamaOrganisationEnum as OrganisationEnum,
} from "../generated/backend";
import {
  DefaultApi as LandbotApi,
  ConfigurationParameters as LandbotConfigurationParameters,
  ErrorContext as LandbotErrorContext,
  RequestContext as LandbotRequestContext,
  ResponseContext as LandbotResponseContext,
} from "../generated/landbot";

export type ApiClientService = "backend" | "landbot";

export type ApiClient<TClient extends ApiClientService> =
  TClient extends "backend" ? BackendApi : LandbotApi;

export const apiUrl: Record<ApiClientService, string> = {
  backend: backendApiUrl,
  landbot: landbotApiUrl,
};

export type TenantIdHeader = {
  mamaDisease: DiseaseEnum;
  mamaOrganisation?: OrganisationEnum;
};

export type RequestContext = BackendRequestContext | LandbotRequestContext;

export type ResponseContext = BackendResponseContext | LandbotResponseContext;

export type ErrorContext = BackendErrorContext | LandbotErrorContext;

export type ConfigurationParameters =
  | BackendConfigurationParameters
  | LandbotConfigurationParameters;

export type PrivateApiContextType = {
  backend: ApiClient<"backend">;
  landbot: ApiClient<"landbot">;
};
